<template>
    <div class="body">
        <div class="container animate-fade-in">
            <div class="header-box">
                <div class="icon-circle">💡</div>
                <h2 class="title-text">2026年7月专属成长计划</h2>
                <p class="subtitle-text">Personalized Study Plan</p>
            </div>

            <div class="plan-wrapper">
                <div class="plan-card">
                    <div class="scroll-container">
                        <ul class="course-list">
                            <li v-for="(course, index) in allCourses" :key="index" class="course-item">
                                <span class="check-icon">✓</span>
                                <span class="name">{{ course }}</span>
                            </li>
                            <li v-if="allCourses.length === 0" class="empty-state">
                                暂未选择课程，请返回挑选
                            </li>
                        </ul>
                    </div>
                    <div class="scroll-shadow" v-if="allCourses.length > 6"></div>
                </div>
            </div>

            <footer class="footer-section">
                <div class="tip-box">
                    <i class="info-icon">i</i>
                    <p>点击“生成计划”，可建立富学宝典学习计划<br><span>（富学宝典每15天更新一次）</span></p>
                </div>
                <button class="confirm-btn" @click="confirmSubmit">
                    <span>生成计划</span>
                    <div class="btn-glow"></div>
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        ReportData: { type: Object, required: false },
        selectedMap: {
            type: Object,
            default: () => ({ A: [], B: [], C: [], D: [], E: [], F: [], G: [] })
        }
    },
    computed: {
        allCourses() {
            const map = this.selectedMap || { A: [], B: [], C: [], D: [], E: [], F: [], G: [] };
            return [
                ...(map.A || []),
                ...(map.B || []),
                ...(map.C || []),
                ...(map.D || []),
                ...(map.E || []),
                ...(map.F || []),
                ...(map.G || [])
            ];
        }
    },
    methods: {
        confirmSubmit() {
            const payload = {
                selectedCourses: {
                    A: this.selectedMap.A || [],
                    B: this.selectedMap.B || [],
                    C: this.selectedMap.C || [],
                    D: this.selectedMap.D || [],
                    E: this.selectedMap.E || [],
                    F: this.selectedMap.F || [],
                    G: this.selectedMap.G || []
                },
            };
            const view = { studyPlan: JSON.stringify(payload) };
            this.$emit('submit', view);
        }
    }
}
</script>

<style scoped>
/* 容器与背景 */
.body {
    background: 
            url("../../assets/26July/logo.png") right top no-repeat,
            url("../../assets/26July/bg.jpg") no-repeat;
    background-size: 100% 100%, cover;
    width: 100%;
    height: 100vh;
    overflow: hidden; /* 防止整页滚动，改为内部滚动 */
    position: relative;
    font-family: 'PingFang SC', sans-serif;
}

/* .body::after {
    content: "";
    position: absolute;
    top: 20px; right: 20px;
    width: 100px; height: 40px;
    background: url("../../assets/26January/logo.png") no-repeat right top;
    background-size: contain;
} */

.container {
    width: 90%;
    max-width: 500px;
    margin: 0 auto;
    height: 100%;
    display: flex;
    flex-direction: column; /* 垂直分布 */
    padding: 6vh 0 4vh;
    box-sizing: border-box;
}

/* 头部样式 */
.header-box {
    text-align: center;
    margin-bottom: 5px;
}

.icon-circle {
    font-size: 40px;
    margin-bottom: 10px;
    filter: drop-shadow(0 0 10px rgba(255, 230, 0, 0.5));
}

.title-text {
    font-size: 22px;
    color: #2d3748;
    margin: 0;
    font-weight: bold;
}

.subtitle-text {
    font-size: 12px;
    color: #333;
    letter-spacing: 2px;
    text-transform: uppercase;
}

/* 核心滚动区域 */
.plan-wrapper {
    flex: 1; /* 自动占据剩余空间 */
    min-height: 0; /* 必须设置 min-height 才能触发 flex 内部滚动 */
    margin: 20px 0;
}

/* 计划清单卡片 */
.plan-card {
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(10px);
    border-radius: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.scroll-container {
    overflow-y: auto;
    padding: 10px 20px;
    /* 隐藏滚动条 (可选) */
    scrollbar-width: thin;
    scrollbar-color: #42a79d transparent;
}

.scroll-container {
    overflow-y: auto;
    padding: 10px 20px;
    /* 隐藏滚动条 (可选) */
    scrollbar-width: thin;
    scrollbar-color: #42a79d transparent;
}

.course-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.course-item {
    display: flex;
    align-items: center;
    padding: 15px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    animation: fadeIn 0.5s ease both;
}

.course-item:last-child {
    border-bottom: none;
}

.check-icon {
    width: 20px;
    height: 20px;
    background: #42a79d;
    color: white;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-right: 15px;
    flex-shrink: 0;
}

.name {
    font-size: 16px;
    color: #333;
    font-weight: 500;
    line-height: 1.4;
}

/* 底部渐变遮罩：提示还可以滚动 */
.scroll-shadow {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to top, rgba(255,255,255,0.9), transparent);
    pointer-events: none;
    border-radius: 0 0 24px 24px;
}

/* 底部操作 */
.footer-section {
    /* margin-top: 20px; */
    text-align: center;
}

.tip-box {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    margin-bottom: 20px;
}

.info-icon {
    background: #42a79d;
    color: #fff;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-style: normal;
    margin-top: 3px;
}

.tip-box p {
    font-size: 13px;
    color: #333;
    margin: 0;
    text-align: left;
    line-height: 1.5;
}

.tip-box span {
    color: #333;
    font-size: 11px;
}

.confirm-btn {
    position: relative;
    background: linear-gradient(135deg, #a2ede6 0%, #42a79d 100%);
    color: white;
    border: none;
    border-radius: 30px;
    padding: 14px 60px;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 8px 20px rgba(208, 51, 39, 0.3);
    transition: all 0.3s;
    overflow: hidden;
}

.confirm-btn:active {
    transform: scale(0.95);
    box-shadow: 0 4px 10px rgba(208, 51, 39, 0.3);
}

.btn-glow {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.2) 0%, transparent 70%);
    animation: rotateGlow 4s linear infinite;
}

/* 动画定义 */
@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

@keyframes rotateGlow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* PC 适配 */
@media screen and (min-width: 786px) {
    .body { background-image: url("../../assets/26July/pcbg.png"); }
    .container { width: 500px; padding-top: 12vh; }
    .plan-card { padding: 10px; }
}

.empty-state {
    padding: 20px;
    text-align: center;
    color: #999;
    font-style: italic;
}
</style>